'use client'

/**
 * Live topics grouped by entry kind, for the filter's sectioned list.
 */

import { useMemo } from 'react'
import { useDocumentStatus, useDocumentView } from '@/document'

import { selectGroupedTopics, selectTopics } from './select-topics'

export type { GroupedTopics } from './select-topics'

export function useGroupedTopics() {
  const doc = useDocumentView()
  const ready = useDocumentStatus()

  const all = useMemo(() => selectTopics(doc), [doc])
  const grouped = useMemo(() => selectGroupedTopics(doc), [doc])

  return { grouped, all, isLoading: !ready }
}
